<template>
  <div id="middle">
    <div class="break py-3">
      <h1 class="text-center font-weight-regular">
        You schedule, We <span class="sokoDeep--text">deliver!</span>
      </h1>
    </div>
    <div class="upper px-8 py-8">
      <v-row class="mt-8">
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="(item, index) in showcase"
          :key="index"
        >
          <div>
            <v-skeleton-loader
              v-if="!loaded"
              type="image"
              v-bind="attrs"
              style="background-color: rgb(254, 254, 254)"
            ></v-skeleton-loader>
            <v-img
              v-else
              :src="require('@/assets/showcase/' + item.image)"
              contain
              v-bind="attrs"
            ></v-img>
            <v-card-title
              class="px-0 pb-1 font-weight-bold text-center d-block basis"
            >
              {{ item.basis }}
            </v-card-title>
            <v-card-text class="px-8 py-0 text-center">
              {{ item.msg }}
            </v-card-text>
            <v-card-subtitle
              class="px-0 pt-1 font-weight-bold text-center d-block"
              ><a :href="item.path" v-if="item.external" class="link">{{
                item.link
              }}</a>
              <router-link :to="item.path" v-else class="link">{{
                item.link
              }}</router-link></v-card-subtitle
            >
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="lower px-8 py-8" style="height: 100%;">
      <v-row align="center" justify="center" no-gutters>
        <v-col cols="12" sm="8" md="5" class="py-10">
          <h1 class="text-center my-3 titan font-weight-regular">
            Ready to schedule?
          </h1>
          <p class="text-center">
            You get instant price feedback, your delivery request is immediately
            routed to the nearest delivery partner based on your location. There
            are no extra cost for scheduling a delivery.
          </p>
          <div class="text-center">
            <v-btn
              x-large
              rounded
              class="sokoDeep white--text my-5 font-weight-bold"
              router
              link
              to="/delivery"
              >schedule now</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Middle",

  data: () => ({
    showcase: [
      {
        basis: "Get instant price feedback",
        link: "schedule a delivery",
        image: "feedback.png",
        path: "/delivery",
        msg: "Schedule, know how much you will be charged and pay instantly.",
      },
      {
        basis: "Become a partner",
        link: "sign up your company",
        path: "http://soko-delivery-merchant.netlify.app",
        image: "partner.png",
        external: true,
        msg:
          "Grow your business and reach new customers by partnering with us.",
      },
      {
        basis: "Deliver the packages",
        link: "login as a rider",
        path: "http://soko-delivery-rider.netlify.app",
        image: "delivery.png",
        external: true,
        msg:
          "Our business patners get the opportunity to add their own riders.",
      },
    ],

    attrs: {
      height: "200",
      width: "300",
      class: "mx-auto",
    },

    loaded: false,
  }),

  created() {
    const readyHandler = () => {
      if (document.readyState == "complete") {
        this.loaded = true;

        document.removeEventListener("readystatechange", readyHandler);
      }
    };

    document.addEventListener("readystatechange", readyHandler);

    readyHandler(); // in case the component has been instantiated lately after loading
  },
};
</script>

<style scoped>
.basis {
  font-size: 1.3rem;
}

.link {
  color: #f55e15;
  font-size: 1.1rem;
}

.break,
.lower {
  background-color: #fdfafa;
}

.break *,
.titan {
  font-family: "Titan One", cursive;
}

.titan {
  color: #5c5c5c;
}

@media (min-width: 960px) {
  .titan {
    font-size: 2.3rem;
  }
}

@media (max-width: 960px) {
  .titan {
    font-size: 2rem;
  }
}
</style>
